"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _iconify = require("@iconify/react/dist/iconify.js");
var _material = require("@mui/material");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var StepTwoFileItem = function StepTwoFileItem(_ref) {
  var index = _ref.index,
    file = _ref.file,
    setInternalFiles = _ref.setInternalFiles,
    currentFile = _ref.currentFile;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isTruncated = _useState2[0],
    setIsTruncated = _useState2[1];
  var checkIsTruncatedRef = (0, _react.useCallback)(function (node) {
    if (!node) return;
    setIsTruncated(node.scrollWidth > node.clientWidth);
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
    key: index,
    sx: {
      marginRight: 0,
      width: isTruncated ? "calc(100% - 39px)" : "100%",
      "& .MuiTypography-root": {
        width: "100%"
      }
    },
    label: /*#__PURE__*/_react["default"].createElement(_material.Box, {
      display: "flex",
      gap: "8px",
      justifyContent: "space-between",
      alignItems: "center"
    }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      ref: checkIsTruncatedRef,
      component: "p",
      className: "text-overflow-ellipsis",
      title: isTruncated ? file.file.name : undefined
    }, file.file.name), file.override && currentFile && file.isChecked && file.file.name !== (currentFile === null || currentFile === void 0 ? void 0 : currentFile.documentName) && /*#__PURE__*/_react["default"].createElement(_material.Box, {
      "data-testid": "warning-icon",
      title: "This file's name does not match, uploading will override the current version but keep the original file's name"
    }, /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
      icon: "ep:warning-filled",
      height: 15,
      color: "333333"
    })), file.isCompleted && /*#__PURE__*/_react["default"].createElement(_material.Box, {
      "data-testid": "completion-icon"
    }, /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
      icon: "akar-icons:check",
      height: 20,
      style: {
        color: "green"
      }
    }))),
    control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
      checked: file.isChecked,
      onChange: function onChange(_, checked) {
        return setInternalFiles(function (prev) {
          return prev.map(function (f) {
            if (f.file.name === file.file.name) {
              return _objectSpread(_objectSpread({}, f), {}, {
                isChecked: checked
              });
            }
            return f;
          });
        });
      }
    })
  });
};
var _default = exports["default"] = StepTwoFileItem;